import { useState } from 'react';
import { useAsyncData } from 'shared/hooks/useAsyncData';
import { ClassTab } from 'modules/jogador/classes/types';
import { CURRENT_PLAN, UPCOMING_SESSIONS, UPGRADE_OPTIONS } from 'modules/jogador/classes/content';
import { fetchMyClasses, MyClassesData } from 'modules/jogador/classes/classesService';

const INITIAL_DATA: MyClassesData = {
  plan: CURRENT_PLAN,
  upcomingSessions: UPCOMING_SESSIONS,
  upgradeOptions: UPGRADE_OPTIONS,
};

export function useClasses() {
  const [activeTab, setActiveTab] = useState<ClassTab>('meu-plano');
  const { data, isLoading, error } = useAsyncData(fetchMyClasses, INITIAL_DATA);

  return { activeTab, setActiveTab, ...data, isLoading, error };
}
